var _path, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseRuler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 12C13.25 13.8109 12.7767 15.4155 12.0511 16.5442C11.3204 17.6809 10.4009 18.25 9.5 18.25C8.59907 18.25 7.67965 17.6809 6.9489 16.5442C6.22331 15.4155 5.75 13.8109 5.75 12C5.75 10.1891 6.22331 8.58451 6.9489 7.45582C7.67965 6.31911 8.59907 5.75 9.5 5.75C10.4009 5.75 11.3204 6.31911 12.0511 7.45582C12.7767 8.58451 13.25 10.1891 13.25 12Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 6.25,
    width: 2.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 18.25,
    width: 2.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 9.25,
    width: 1.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 12.25,
    width: 2.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 15.25,
    width: 1.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseRuler);
export default __webpack_public_path__ + "static/media/ellipse-ruler.80d849d9.svg";
export { ForwardRef as ReactComponent };